export enum EventTypeEnum {
    SOS_EVENT = 'sos',
    BATTERY_CONNECTION_EVENT = 'battery_connection',
    BATTERY_DISCONNECT_EVENT = 'battery_disconnect',
    JAMMING_EVENT = 'jamming',
    SPEEDING_EVENT = 'speeding',
    HARD_BRACKING_EVENT = 'hard_bracking',
    MAINTENANCE_EVENT = 'maintenance',
    GEOFENCE_EXIT_EVENT = 'geofence_exit',
    GEOFENCE_ENTER_EVENT = 'geofence_enter',
    LOW_BATTERY_EVENT = 'low_battery',
    OPEN_FUEL_TANK = 'open_fuel_tank',
    CLOSE_FUEL_TANK = 'close_fuel_tank',
    OPEN_BACK_DOOR = 'open_back_door',
    CLOSE_BACK_DOOR = 'close_back_door',
    OPEN_SIDE_DOOR = 'open_side_door',
    CLOSE_SIDE_DOOR = 'close_side_door',
    VEHICLE_ALARM_ON = 'vehicle_alarm_on',
    VEHICLE_ALARM_OFF = 'vehicle_alarm_off',
    UNKNOWN_EVENT = 'unknown_event',
}
